(function () {
  var sections = document.querySelectorAll("[data-recipes-hero]");
  var mapUrl = "https://essykings.github.io/JavaScript/map.png";
  var mapHrefPromise = null;

  if (!sections.length) return;

  sections.forEach(function (section) {
    section.classList.add("frh-is-ready");
    initTypewriter(section);
    initGlassMap(section);
  });

  function initTypewriter(section) {
    var target = section.querySelector("[data-typewriter-name]");
    if (!target) return;

    var names = (section.getAttribute("data-names") || "")
      .split(",")
      .map(function (name) {
        return name.trim();
      })
      .filter(Boolean);

    if (!names.length) return;

    var speed = Number(section.getAttribute("data-type-speed")) || 85;
    var pause = Number(section.getAttribute("data-type-pause")) || 1700;
    var nameIndex = 0;
    var charIndex = 0;
    var deleting = false;

    function tick() {
      var name = names[nameIndex];

      if (!deleting) {
        charIndex += 1;
        target.textContent = name.slice(0, charIndex);

        if (charIndex >= name.length) {
          deleting = true;
          window.setTimeout(tick, pause);
          return;
        }
      } else {
        charIndex -= 1;
        target.textContent = name.slice(0, charIndex);

        if (charIndex <= 0) {
          deleting = false;
          nameIndex = (nameIndex + 1) % names.length;
          window.setTimeout(tick, Math.max(speed, 180));
          return;
        }
      }

      window.setTimeout(tick, deleting ? Math.max(speed * 0.52, 35) : speed);
    }

    target.textContent = "";
    window.setTimeout(tick, 650);
  }

  function initGlassMap(section) {
    var feImage = section.querySelector("[data-frh-glass-map]");
    if (!feImage) return;

    if (window.CSS) {
      var supportsBackdropFilter =
        window.CSS.supports("backdrop-filter", "url(#glass)") ||
        window.CSS.supports("-webkit-backdrop-filter", "url(#glass)");

      if (!supportsBackdropFilter) {
        section.classList.add("frh-glass-fallback");
      }
    }

    getMapHref()
      .then(function (href) {
        setFeImageHref(feImage, href);
      })
      .catch(function () {
        section.classList.add("frh-glass-fallback");
        setFeImageHref(feImage, mapUrl);
      });
  }

  function getMapHref() {
    if (!mapHrefPromise) {
      mapHrefPromise = fetch(mapUrl)
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Failed to load glass map");
          }

          return response.blob();
        })
        .then(function (blob) {
          return URL.createObjectURL(blob);
        });
    }

    return mapHrefPromise;
  }

  function setFeImageHref(feImage, href) {
    feImage.setAttribute("href", href);
    feImage.setAttributeNS("http://www.w3.org/1999/xlink", "href", href);
  }
})();
